import { theme } from '@salecycle/ui-component-library';

export const TEMPLATE_STATUS_COLOURS = {
  DRAFT: theme.vars.newColor.orange1,
  LIVE: theme.vars.newColor.green2,
};
